define('directives/mysetting/operationInfo.directives',['app'], function (app) {
    app.directive('operationInfoDirective', ['$state', 'projectManageService','modBussService', 'auiUpload','OpenUp',
        function ($state, projectManageService,modBussService, auiUpload, OpenUp) {
            return {
                restrict: 'E',
                replace: true,
                require: "?ngModel",
                templateUrl: 'directives/mysetting/operationInfo.html',
                link: function ($scope, $element, attrs, ngModelCtrl) {
                    var Model = $scope.Model;
                    Model.isShowOperationList = true
                    Model.checkSceneFlag =false
                    Model.appDownloadUrlList = sysParamCfg.appDownloadList
                    Model.printScreen = ''
                    Model.printScreenWH = ''
                    Model.productShowcase = ''
                    Model.appFlag = false
                    Model.pcWeb = false
                    Model.otherInfo = false
                    Model.appDownloadUrlTipMsg = '若APP已上线，请提供APP在主流应用市场（如华为应用市场，Appstore，应用宝，豌豆荚等）下载链接。'
                    Model.categoryList = []
                    Model.categoryOneList = []
                    Model.categoryOneLabel = {}
                    Model.categoryTwoList = []
                    Model.changeFlag = false
                    Model.operationHasChange = false

                    Model.operationInfo = {
                        appDownloadUrl: '',
                        website: '',
                        Icp: '',
                    }

                    Model.chooseSceneList = []

                    getIndustryCategoryList()

                    Model.chooseScene = chooseScene

                    function chooseScene(item) {
                        if(Model.isAudting) {
                            return
                        }
                        $scope.greenSubmit()
                        if (AUI.BaseJSUtil.contains(Model.chooseSceneList, item.value)) {
                            AUI.BaseJSUtil.arrayRemove(Model.chooseSceneList,  item.value);
                            item.isChecked = false
                        } else {
                            Model.chooseSceneList.push(item.value);
                            item.isChecked = true
                        }
                        setSceneList()
                        Model.checkSceneFlag = (Model.chooseSceneList.length === 0)
                        Model.valueChange()
                    }

                    function setSceneList() {
                        for(var i = 0 ; i< Model.sceneList.length; i++) {
                            if(Model.sceneList[i].label === 'APP') {
                                Model.appFlag = Model.sceneList[i].isChecked
                            }
                            if(Model.sceneList[i].label === 'PC网站') {
                                Model.pcWeb = Model.sceneList[i].isChecked
                            }
                            if(Model.sceneList[i].label === '其他') {
                                Model.otherInfo = Model.sceneList[i].isChecked
                            }
                        }
                    }

                    function upload2openUP(files, options, img, imgWH) {
                        auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {

                            if (fileUrl) {
                                var changed = fileUrl && fileUrl !== Model[img];
                                if(changed) {
                                    Model[img] = fileUrl;
                                    Model.operationHasChange = true
                                    $scope.greenSubmit()
                                }
                                //删除url
                                AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                                    $scope.$apply(function () {
                                        Model[imgWH] = wh;
                                    });
                                });
                            }
                        });
                    }

                    Model.uploadPrintScreen = function (files, options) {
                        upload2openUP(files, options, 'printScreen', 'printScreenWH');
                    };

                    Model.uploadProductShowcase = function (files, options) {
                        upload2openUP(files, options, 'productShowcase', null);
                    }

                    Model.validAppDownloadUrl = validAppDownloadUrl()
                    function validAppDownloadUrl() {
                        return{
                            test: function (value) {

                                return value && !checkAppDownloadUrl(value)

                            }
                        }
                    }

                    function checkAppDownloadUrl(value) {
                        var urlFlag = true
                        for(var i = 0; i < Model.appDownloadUrlList.length; i++) {
                            if(value.startsWith(Model.appDownloadUrlList[i])) {
                                urlFlag = false
                            }
                        }
                        return urlFlag
                    }

                    Model.categoryChange = categoryChange

                    function categoryChange(value) {
                        if(Model.categoryCode && Model.merchantBusinessInfo && Model.categoryCode.value !==  Model.merchantBusinessInfo.categoryCode) {
                            Model.operationHasChange = true
                            $scope.greenSubmit()
                        }
                        Model.categoryTwoList = []
                        Model.subCategoryCode = undefined
                        var list = Model.categoryOneLabel[value]
                        if(list.length > 0) {
                            for(var i = 0; i< list.length; i++) {
                                Model.categoryTwoList.push({
                                    label: list[i].nameCn,
                                    value:  list[i].categoryCode
                                })
                            }
                        }
                    }

                    Model.subCategoryCodeChange = function (value) {
                        if( Model.subCategoryCode && Model.merchantBusinessInfo && Model.subCategoryCode.value !==  Model.merchantBusinessInfo.subCategoryCode) {
                            Model.operationHasChange = true
                            $scope.greenSubmit()
                        }
                    }

                    function setData() {
                        Model.chooseSceneList = Model.merchantBusinessInfo.businessScene.split('|')
                        Model.categoryOneList.forEach(function (item) {
                            if(item.value === Model.merchantBusinessInfo.categoryCode ) {
                                Model.categoryCode = {
                                    label: item.label,
                                    value: Model.merchantBusinessInfo.categoryCode
                                }
                                categoryChange(item.label)
                            }
                        })
                        Model.categoryTwoList.forEach(function (item) {
                            if(item.value === Model.merchantBusinessInfo.subCategoryCode) {
                                Model.subCategoryCode = {
                                    label: item.label,
                                    value: item.value
                                }
                            }
                        })
                        Model.chooseSceneList.forEach(function (item) {
                            Model.sceneList.forEach(function (item1) {
                                if(item == item1.value) {
                                    item1.isChecked = true
                                }
                            })
                        })

                        setSceneList()

                        Model.chooseSceneList.forEach(function (item) {
                            if(item === '1') {
                                Model.printScreen = Model.merchantBusinessInfo.appScreenshot
                                Model.operationInfo.appDownloadUrl = Model.merchantBusinessInfo.appDownloadUrl
                                setDrawImage('printScreen','printScreenWH')
                            }else if(item === '2') {
                                Model.operationInfo.website = Model.merchantBusinessInfo.website
                                Model.operationInfo.Icp = Model.merchantBusinessInfo.icp
                            }else if(item === '3') {
                                Model.productShowcase = Model.merchantBusinessInfo.productShowcase
                            }
                        })
                    }

                    function setDrawImage(type, typewh) {
                        AUI.HTMLUtil.drawImage(180, 120, Model[type], function (wh) {
                            $scope.$apply(function () {
                                Model[typewh] = wh;
                            });
                        });
                    }

                    function getIndustryCategoryList() {
                        OpenUp.getIndustryCategoryList({ req: {}}).then(function (data) {
                            if(data.resultCode === 0 && data.industryCategoryList && data.industryCategoryList.length > 0) {
                                Model.categoryList = data.industryCategoryList
                                for(var i = 0; i < Model.categoryList.length; i++) {
                                    Model.categoryOneList.push({
                                        label: Model.categoryList[i].nameCn,
                                        value: Model.categoryList[i].categoryCode
                                    })
                                    if(data.industryCategoryList[i].subIndustryCategorys && data.industryCategoryList[i].subIndustryCategorys.length > 0) {

                                        Model.categoryOneLabel[data.industryCategoryList[i].nameCn] = data.industryCategoryList[i].subIndustryCategorys
                                    }
                                }
                            }
                            getBusinessInfo()
                        })
                    }

                    function getBusinessInfo() {
                        OpenUp.getOperationInfo({ req: {}}).then(function (res) {
                            if(res.resultCode === 0) {
                                if(res.merchantBusinessInfo) {
                                    Model.changeFlag = true
                                    Model.merchantBusinessInfo = res.merchantBusinessInfo
                                    setData()
                                }else {
                                    Model.operationHasChange = true
                                    $scope.greenSubmit()
                                }
                            }
                        })
                    }

                     Model.valueChange = function () {
                        if(Model.changeFlag) {
                            if(Model.chooseSceneList.length !== Model.merchantBusinessInfo.businessScene.split('|').length) {
                                Model.operationHasChange = true
                                $scope.greenSubmit()
                            }else {
                                if(Model.chooseSceneList.sort().toString() !== Model.merchantBusinessInfo.businessScene.split('|').sort().toString()) {
                                    Model.operationHasChange = true
                                    $scope.greenSubmit()
                                }else {
                                    Model.chooseSceneList.forEach(function (item) {
                                        if(item === '1') {
                                            if(Model.operationInfo.appDownloadUrl !== Model.merchantBusinessInfo.appDownloadUrl) {
                                                Model.operationHasChange = true
                                                $scope.greenSubmit()
                                            }
                                        }
                                        if(item === '2') {
                                            if(Model.operationInfo.website !== Model.merchantBusinessInfo.website) {
                                                Model.operationHasChange = true
                                                $scope.greenSubmit()
                                            }
                                            if(Model.operationInfo.Icp !== Model.merchantBusinessInfo.icp) {
                                                Model.operationHasChange = true
                                                $scope.greenSubmit()
                                            }
                                        }
                                    })
                                }
                            }
                            if( Model.subCategoryCode && Model.subCategoryCode.value !==  Model.merchantBusinessInfo.subCategoryCode) {
                                Model.operationHasChange = true
                                $scope.greenSubmit()
                            }
                            if(Model.categoryCode && Model.categoryCode.value !==  Model.merchantBusinessInfo.categoryCode) {
                                Model.operationHasChange = true
                                $scope.greenSubmit()
                            }
                        }else {
                            Model.operationHasChange = true
                            $scope.greenSubmit()
                        }
                    }
                }
            }
        }])
});
